module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-wrapper"><div class="dialog modal-dialog dialog-edu-global"><div class="dialog-mask"></div><div class="dialog-main"><button class="vertical-a iconfont icon-close close-edu-global">x</button><div class="dialog-body"><div class="add-form-dialog-body"><div class="title">教育プロフェッショナル版申請</div><div class="body"><p>以下の資料をご準備の上、「support@umu.com」にご連絡ください。</p><p>1.登録済みのUMUアカウント情報（ユーザー名、メール、または携帯電話番号）。</p><p>2. 現職教師の在職証明書またはその他の有効性のある証明証</p></div><div class="footer"><button class="btn-confirm close-edu-global">わかりました</button></div></div></div></div></div></div>\n';

}
return __p
}